import PazienteAllegatiRepositoryList from "../allegatirepository/components/PazienteAllegatiRepositoryList.vue";
export default {
    PazienteAllegatiRepositoryList,
};
